import axios from "axios";
import { getMasterKey, encryptData, decryptData } from "./crypto";
import { generateEmbedding } from "./ml";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "stream_access_token";

export const tokenStore = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (t) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};

export const api = axios.create({ baseURL: API });

api.interceptors.request.use(async (config) => {
  const token = tokenStore.get();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  
  if (config.url && config.url.includes("/blocks") && config.data && (config.method === "post" || config.method === "patch")) {
    // Generate embedding first (on plaintext)
    if (config.data.content && config.data.type === "text") {
      const emb = await generateEmbedding(config.data.content);
      if (emb) config.data.embedding = emb;
    }
    
    const mk = getMasterKey();
    if (mk) {
      if (config.data.content) config.data.content = encryptData(config.data.content, mk);
      if (config.data.caption) config.data.caption = encryptData(config.data.caption, mk);
    }
  }
  
  return config;
});

api.interceptors.response.use(
  (response) => {
    const mk = getMasterKey();
    if (mk && response.config.url && response.config.url.includes("/blocks") && response.data) {
      if (Array.isArray(response.data)) {
        response.data.forEach(b => {
          if (b.content) b.content = decryptData(b.content, mk);
          if (b.caption) b.caption = decryptData(b.caption, mk);
        });
      } else if (response.data.id) {
        if (response.data.content) response.data.content = decryptData(response.data.content, mk);
        if (response.data.caption) response.data.caption = decryptData(response.data.caption, mk);
      }
    }
    return response;
  },
  (error) => Promise.reject(error)
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
